<div class="card mt-3">
  <div class="card-header">
    Optimized Portfolio Weights

    <button
      type="button"
      class="float-end"
      mat-flat-button
      color="primary"
      (click)="saveWeights()"
      [disabled]="totalWeight && totalWeight != 100"
    >
      Save & Reload
    </button>
    @if (totalWeight && totalWeight !== 100) {
      <span class="weight-error-label"
        >My Portfolio total weight is not 100%! (<b>{{ totalWeight }}</b
        >%)</span
      >
    }
  </div>
  <div class="card-body">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="w-100 mat-small-table table-with-input table-hover"
    >
      @for (col of optimizedPortfolioWeightsColumns; track col.id) {
        <ng-container matColumnDef="{{ col.id }}">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="col.type == 99"
            [class.text-end]="col.type == 2 || col.type == 3 || col.textRight"
            [class.pe-4]="col.type == 2 || col.type == 3 || col.textRight"
          >
            @if (col.type != 99) {
              <span
                [class.text-end]="
                  col.type == 2 || col.type == 3 || col.textRight
                "
                >{{ col.label }}</span
              >
            }
            @if (col.type == 99) {
              <span>
                <mat-form-field>
                  <mat-label [class.text-end]="col.textRight"
                    >My portfolio source</mat-label
                  >
                  <mat-select
                    placeholder="My portfolio source"
                    [(ngModel)]="selectedType"
                    name="selected-type"
                  >
                    @for (s of selectList; track s.id) {
                      <mat-option
                        [value]="s.label"
                        (click)="onSelectChange(s.id)"
                        >{{ s.label }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </span>
            }
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [class.text-end]="col.type == 2 || col.type == 3 || col.textRight"
            [class.pe-4]="col.type == 2 || col.type == 3 || col.textRight"
          >
            @switch (col.type) {
              @case (1) {
                <div>{{ element[col.id] }}</div>
              }
              @case (2) {
                <div>{{ element[col.id] * 100 | number: "1.0-2" }}%</div>
              }
              @case (3) {
                <div>
                  {{ element[col.id] | number: "1.0-2" }}
                  @if (col.suffix) {
                    <span>{{ col.suffix }}</span>
                  }
                </div>
              }
              @case (4) {
                <div>
                  <mat-form-field
                    class="max-100 table-input-suffix"
                    appearance="outline"
                  >
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="element[col.id]"
                      step="0.1"
                    />
                    @if (col.suffix) {
                      <span matSuffix>{{ col.suffix }}</span>
                    }
                  </mat-form-field>
                </div>
              }
              @case (5) {
                <div>
                  <span
                    class="underline-on-hover ms-2 text-truncate"
                    (click)="onCompanyInfoClick(element)"
                    >{{ element[col.id] }}</span
                  >
                </div>
              }
              @case (99) {
                <div>
                  <mat-form-field
                    class="max-100 table-input-suffix"
                    appearance="outline"
                  >
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="element[col.id]"
                      step="0.1"
                      (ngModelChange)="checkWeights()"
                    />
                    <span matSuffix>%</span>
                  </mat-form-field>
                </div>
              }
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="columnLabels"></tr>
      <tr mat-row *matRowDef="let row; columns: columnLabels"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[10, 20, 30]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
